import { Input, Button, VStack, HStack, Text, Divider, useBreakpointValue, Box, Icon, Flex } from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import { MdEdit } from 'react-icons/md'
import { useReservation } from './ReservationContext'
import ReservationInfoPanel from './ReservationInfoPanel'

type FormData = {
  title: string
}

const ReservationCreateTitle: React.FC = () => {
  const { state, goToNext, goBack } = useReservation()
  const isMobile = useBreakpointValue({ base: true, md: false })
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid }
  } = useForm<FormData>({
    mode: 'onBlur',
    defaultValues: {
      title: state.title || ''
    }
  })

  const titleValue = watch('title')

  const onSubmit = (data: FormData) => {
    goToNext({ title: data.title })
  }

  const handleNext = handleSubmit(onSubmit)

  return (
    <VStack spacing={6} align="stretch" width="100%" maxW="100%">
      <Flex alignItems="center" gap="8px">
        <Icon as={MdEdit} boxSize="20px" color="gray.700" />
        <Text fontSize="18px" fontWeight="600" wordBreak="break-word" whiteSpace="normal">
          会議名を入力してください
        </Text>
      </Flex>
      <Text fontSize="14px" fontWeight="600" color="red.500" whiteSpace="pre-line" wordBreak="break-word">
        ※会議名は他の方も閲覧できます。{'\n'}個人名等は使わないようにしましょう。
      </Text>
      <Input
        placeholder="会議タイトルを入力"
        size="lg"
        w="100%"
        maxW="100%"
        {...register('title', {
          required: '会議名を入力してください',
          validate: (value) => value.trim().length > 0 || '会議名を入力してください'
        })}
      />
      {errors.title && (
        <Text color="red.500" fontSize="14px" wordBreak="break-word" whiteSpace="normal">
          {errors.title.message}
        </Text>
      )}
      <Divider />
      <Box w="100%" maxW="100%">
        <ReservationInfoPanel />
      </Box>
      {isMobile ? (
        <VStack spacing={3} mt={4} w="100%">
          <Button onClick={goBack} size="md" width="100%" variant="outline">戻る</Button>
          <Button colorScheme="green" onClick={handleNext} isDisabled={!isValid || !titleValue?.trim()} size="md" width="100%">
            次へ
          </Button>
        </VStack>
      ) : (
        <HStack justify="space-between" mt={4} w="100%">
          <Button onClick={goBack} size="md">戻る</Button>
          <Button colorScheme="green" onClick={handleNext} isDisabled={!isValid || !titleValue?.trim()} size="md">
            次へ
          </Button>
        </HStack>
      )}
    </VStack>
  )
}

export default ReservationCreateTitle 